import { render, staticRenderFns } from "./dormCount.vue?vue&type=template&id=40358046&scoped=true&"
import script from "./dormCount.vue?vue&type=script&lang=js&"
export * from "./dormCount.vue?vue&type=script&lang=js&"
import style0 from "./dormCount.vue?vue&type=style&index=0&id=40358046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40358046",
  null
  
)

export default component.exports